import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import useResponsive from '../hooks/useResponsive';

const Layout = () => {
  const { isSmallScreen } = useResponsive();
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar container with sticky positioning */}
      <Box sx={{ position: 'sticky', top: 0, width: isSmallScreen ? '0px' : 280 }}>
        <Sidebar />
      </Box>

      {/* Main content area */}
      <Box sx={{ flexGrow: 1, bgcolor: '#fafafa' }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
